// @ts-strict
import {type ReactElement} from 'react';

import SupportMessageActions from './SupportMessageActions';
import SupportMessageFields from './SupportMessageFields';
import SupportMessageProvider, {type SupportMessageProviderProps} from './SupportMessageProvider';

type SupportMessageFormProps = Omit<SupportMessageProviderProps, 'children'> & {
  onCancel?: () => void;
};

// The modal composes these three itself so the actions can live in its sticky footer.
const SupportMessageForm = ({
  onCancel,
  ...providerProps
}: SupportMessageFormProps): ReactElement => (
  <SupportMessageProvider {...providerProps}>
    <div className="flex min-h-full grow flex-col gap-6">
      <SupportMessageFields />
      <SupportMessageActions className="mt-auto" onCancel={onCancel} />
    </div>
  </SupportMessageProvider>
);

export default SupportMessageForm;
